// src/shared/utils/globalScripts.js
import React from "react";
import * as Sentry from "@sentry/react";
import Hotjar from "@hotjar/browser";

export function initSentry() {
  Sentry.init({
    dsn:
      "https://f9bb68fde5cb0daa92edf8e6842b3603@o255514.ingest.us.sentry.io/4509326600241152",
    sendDefaultPii: true,
  });
}

export function injectHotjar() {
  const siteId = 6369144;
  const hotjarVersion = 6;
  Hotjar.init(siteId, hotjarVersion);
}

export function injectGoogleAnalytics() {
  const googleAnalytics = document.createElement("script");
  googleAnalytics.async = true;
  googleAnalytics.src =
    "https://www.googletagmanager.com/gtag/js?id=G-KYKEZ87E5M";
  document.head.appendChild(googleAnalytics);

  const googleAnalyticsConfig = document.createElement("script");
  googleAnalyticsConfig.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'G-KYKEZ87E5M');
  `;
  document.head.appendChild(googleAnalyticsConfig);
}

export const LiveChatScript = () => {
  React.useEffect(() => {
    // Start of Talkdesk Code
    var webchat;
    (function(window, document, node, props, configs) {
      if (window.TalkdeskChatSDK) {
        console.error("TalkdeskChatSDK already included");
        return;
      }
      var divContainer = document.createElement("div");
      divContainer.id = node;
      divContainer.style.setProperty("--chat-z-index", "1200");
      document.body.appendChild(divContainer);
      var src = "https://talkdeskchatsdk.talkdeskapp.com/v2/talkdeskchatsdk.js";
      var script = document.createElement("script");
      var firstScriptTag = document.getElementsByTagName("script")[0];
      script.type = "text/javascript";
      script.charset = "UTF-8";
      script.id = "tdwebchatscript";
      script.src = src;
      script.async = true;
      firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
      script.onload = function() {
        webchat = TalkdeskChatSDK(node, props);
        webchat.init(configs);

        const zIndexStyle = document.createElement("style");
        zIndexStyle.id = "td-webchat-zindex";
        // Talkdesk sets --chat-z-index: 99999 on .tdw-widget-wrapper; override the variable.
        zIndexStyle.textContent = `
          #tdWebchat,
          #tdWebchat .tdw-widget-wrapper {
            --chat-z-index: 1200 !important;
          }
        `;
        document.head.appendChild(zIndexStyle);
        /*
         * Send custom data from your website to TalkDesk!
         * If you would like to do it, you need to remove the following commented code and
         * modify the webchat.setContextParam parameters to pass in the data you need.
         */
        /*function setContext() {
           webchat.setContextParam({ "var1": "value1", "var2": "value2", "var3": 100 })
         }
         // Send data when the chat conversation is initiated
         webchat.onConversationStart = function() {
           setContext()
         }
         // Send data when the chat widget is open
         webchat.onOpenWebchat = function() {
           setContext()
         }*/
      };
    })(
      window,
      document,
      "tdWebchat",
      {
        touchpointId: "bd36a41105b3485892b7b413bd0dc7a5",
        accountId: "",
        region: "td-us-1",
      },
      {
        enableValidation: false,
        enableEmoji: true,
        enableUserInput: true,
        enableAttachments: true,
      }
    );
    // End of Talkdesk Code

    return () => {
      const zIndexStyle = document.querySelector("#td-webchat-zindex");
      if (zIndexStyle) {
        zIndexStyle.remove();
      }
      const script = document.querySelector("#tdwebchatscript");
      if (script) {
        script.remove();
      }
      const div = document.querySelector("#tdWebchat");
      if (div) {
        div.remove();
      }
    };
  }, []);

  return null;
};
